import React from "react";
import { ManagePayrollFrequencyContainer } from "../../containers";

const ManagePayrollFrequency = (props) => {
  return <ManagePayrollFrequencyContainer {...props} />;
};

export default ManagePayrollFrequency;
